import { withChartLayout } from 'components/common';
import PostpartumAssessment from 'components/features/chart/system-assessment/postpartum-assessment/PostpartumAssessment';

const PostpartumAssessmentPage = withChartLayout('Postpartum Assessment')(PostpartumAssessment);
export default PostpartumAssessmentPage;
